import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addPostprocessNotification } from "../../redux/actions/notificationActions";
import authService from "../../utils/auth/authService";

const notificationHubUrl = `${process.env.REACT_APP_FRONT_SERVICE_API}/notifications/postprocessing`;

const PostprocessingProvider = () => {
  const [connection, setConnection] = useState(null);
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const start = () => {
    if (connection) {
      if (connection.connectionState === "Connected") {
        return;
      }
      connection
        .start()
        .then(() => {
          connection.on("PostprocessingNotificationReceived", (message) => {
            const postprocessingNotification = {
              id: message.requestId,
              type: "postprocessing",
              body: message,
              ts: message.timestampUtc,
            };
            console.log(
              "postprocessing notification received",
              postprocessingNotification
            );
            dispatch(addPostprocessNotification(postprocessingNotification));
          });
          connection.onclose(() => {
            setTimeout(() => start(), 3000);
          });
        })
        .catch(async (e) => {
          console.log(
            "Connection failed: ",
            JSON.stringify(e),
            e.statusCode,
            new Date()
          );
          setTimeout(() => start(), 3000);
        });
    }
  };
  useEffect(() => {
    async function subscribeToHub() {
      const newConnection = new HubConnectionBuilder()
        .withUrl(`${notificationHubUrl}`, {
          accessTokenFactory: () => {
            return authService.acquireToken();
          },
        })
        .configureLogging(LogLevel.Warning) // Hide Info/Debug logs from console
        .build();
      setConnection(newConnection);
    }
    if (!user || !user.identity) {
      return;
    }
    subscribeToHub();
  }, [user]);

  useEffect(() => {
    start();
  }, [connection]);

  return null;
};

export default PostprocessingProvider;
